import { Routes } from '@angular/router'
import { Error403Component } from '@isl-core/components/error403/error403.component'
import { UserRolesConditionEnum, UserRolesEnum } from '@isl-core/enums/user-roles.enum'
import { AuthGuard } from '@isl-core/guards/auth.guard'

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/reports',
        pathMatch: 'full'
    },
    {
        canActivate: [AuthGuard],
        path: 'error/403',
        component: Error403Component
    },
    {
        canActivate: [AuthGuard],
        path: 'admin',
        loadChildren: () => import('@isl-features/employees/employees.routes').then((m) => m.routes),
        data: {
            permission: {
                roles: [
                    UserRolesEnum.Payroll,
                    UserRolesEnum.LabourOffice,
                    UserRolesEnum.Foreman,
                    UserRolesEnum.RestrictedForeman
                ],
                condition: UserRolesConditionEnum.Any
            }
        }
    },
    {
        canActivate: [AuthGuard],
        path: 'admin',
        loadChildren: () => import('@isl-features/ships/ships.routes').then((m) => m.routes),
        data: {
            permission: {
                roles: [
                    UserRolesEnum.Payroll,
                    UserRolesEnum.LabourOffice,
                    UserRolesEnum.Foreman,
                    UserRolesEnum.RestrictedForeman
                ],
                condition: UserRolesConditionEnum.Any
            }
        }
    },
    {
        path: 'labourSheets',
        loadChildren: () => import('@isl-features/labour-sheets/labour-sheets.routes').then((m) => m.routes)
    },
    {
        canActivate: [AuthGuard],
        path: 'reports',
        loadChildren: () => import('@isl-features/four-weekly/four-weekly.routes').then((m) => m.routes)
    }
]
